// "createdByUser.firstname" -> value of row.createdByUser?.firstname
export const getPath = (object, path) =>
  String(path)
    .split(".")
    .reduce((acc, key) => (acc === null || acc === undefined ? undefined : acc[key]), object);

// Sets a (possibly nested) path, creating objects on the way
export const setPath = (object, path, value) => {
  const keys = String(path).split(".");
  let target = object;
  keys.slice(0, -1).forEach((key) => {
    if (typeof target[key] !== "object" || target[key] === null) target[key] = {};
    target = target[key];
  });
  target[keys[keys.length - 1]] = value;
  return object;
};
